export var AppRequestMethod = /*#__PURE__*/function (AppRequestMethod) {
  // WARNING: In some situations, GET requests will be read from browser cache.
  // may happen in cypress for example. Recommended to use POST 
  AppRequestMethod[AppRequestMethod["GET"] = 0] = "GET";
  AppRequestMethod[AppRequestMethod["POST"] = 1] = "POST";
  return AppRequestMethod;
}(AppRequestMethod || {});